module.exports = __webpack_public_path__ + "media/src/images/page01_zu_worksheet0201-2ba66f3ec15e988f44862b2bb8dfc89d.gif";